<template>
  <div v-if="$store.state.g_compartir_matriz == 'true'" class="container-fluid">
    <div id="mySidenav" class="sidenav">
      <a
        @click="mostrarUrl()"
        data-toggle="modal"
        data-target="#modal_url"
        id="about"
        ><i class="fas fa-share-alt"></i> Compartir Matriz</a
      >
    </div>
    <div
      v-if="$store.state.g_descargar_matriz == 'true'"
      id="mySidenav"
      class="sidenav"
    >
      <a
        @click="descargarExcelFinal()"
        id="download"
        data-toggle="modal"
        data-target="#modal_mostrar_matriz"
        ><i class="fas fa-file-download"></i> Descargar Matriz</a
      >
    </div>
    <div v-if="$store.state.user_auth" id="mySidenav" class="sidenav">
      <a id="copiarM" data-toggle="modal" data-target="#modal_reg_proceso"
        ><i class="fas fa-copy"></i> Copiar Matriz</a
      >
    </div>
    <div
      class="table-responsive v-movil-divs"
      :style="
        $store.state.user_auth ? 'max-height: 91vh;' : 'max-height: 100vh;'
      "
    >
      <table
        class="table_excel table-borderless"
        style="border-collapse: collapse !important"
        FRAME="void"
        RULES="all"
      >
        <thead>
          <tr>
            <td rowspan="3" colspan="2" style="height: 15px">
              <div v-if="logo_cliente == '' || logo_cliente == 'undefined'">
                Sin logo
              </div>
              <div v-else>
                <img
                  :src="logo_cliente"
                  class="img_fluid rounded"
                  style="width: 15px"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>Nombre de la Empresa:</td>
            <th colspan="2">{{ cliente_empresa.c_empresa }}</th>
            <td colspan="3">Actividad Económica:</td>
            <th colspan="2">{{ cliente_empresa.c_actividad }}</th>
            <td colspan="3">Nombre del Centro de trabajo:</td>
            <th colspan="3">{{ cliente_empresa.c_trabajo }}</th>
            <td>Ciudad:</td>
            <th colspan="2">{{ cliente_empresa.c_ciudad }}</th>
            <td>Departamento:</td>
            <th>{{ cliente_empresa.c_departamento }}</th>
          </tr>
          <tr>
            <td>Número de trabajadores</td>
            <th colspan="2">{{ cliente_empresa.c_num_trabajadores }}</th>
            <td colspan="3">Clase de riesgo:</td>
            <th colspan="2">
              <div
                v-for="(clase_riesgo, index) of cliente_empresa.c_clase_riesgo"
                :key="index.clase_riesgo"
              >
                <template v-if="cliente_empresa.c_clase_riesgo">
                  {{ clase_riesgo }}
                </template>
              </div>
            </th>
            <td colspan="3">Fecha Actualización:</td>
            <th colspan="3">{{ cliente_empresa.c_fecha }}</th>
            <td>Responsable empresa:</td>
            <th colspan="2">{{ cliente_empresa.c_responsable }}</th>
            <td>Visita atendida por:</td>
            <th>{{ cliente_empresa.c_visita }}</th>
          </tr>
          <tr>
            <td style="height: 15px" colspan="10"></td>
          </tr>
          <tr>
            <th
              rowspan="2"
              class="table_letra"
              style="background-color: #d9d9d9; color: #000"
            >
              PROCESO
            </th>
            <th
              rowspan="2"
              class="table_letra"
              style="background-color: #d9d9d9; color: #000"
            >
              ZONA/LUGAR
            </th>
            <th
              rowspan="2"
              class="table_letra"
              style="background-color: #d9d9d9; color: #000"
            >
              ACTIVIDADES
            </th>
            <th
              rowspan="2"
              class="table_letra"
              style="background-color: #d9d9d9; color: #000"
            >
              TAREAS
            </th>
            <th
              rowspan="2"
              class="table_letra"
              style="background-color: #d9d9d9; color: #000"
            >
              TAREA RUTINARIO (SI O NO)
            </th>
            <th
              colspan="2"
              class="table_letra"
              style="background-color: #a21c26; color: #fff"
            >
              PELIGRO
            </th>
            <th
              rowspan="2"
              class="table_letra"
              style="background-color: #d98530; color: #fff"
            >
              EFECTOS POSIBLES
            </th>
            <th
              colspan="3"
              class="table_letra"
              style="background-color: #cc631d; color: #fff"
            >
              CONTROLES EXISTENTES
            </th>
            <th
              colspan="7"
              class="table_letra"
              style="background-color: #eec425; color: #000"
            >
              EVALUACIÓN DEL RIESGO
            </th>
            <th
              colspan="1"
              class="table_letra"
              style="background-color: #d9d9d9; color: #000"
            >
              VALORACIÓN DEL RIESGO
            </th>
            <th
              colspan="2"
              class="table_letra"
              style="background-color: #cc631d; color: #fff"
            >
              CRITERIOS PARA ESTABLECER CONTROLES
            </th>
            <th
              colspan="5"
              class="table_letra"
              style="background-color: #d98530; color: #fff"
            >
              MEDIDAS DE INTERVENCIÓN
            </th>
          </tr>
          <tr>
            <th
              class="table_letra"
              style="background-color: #a21c26; color: #fff"
            >
              DESCRIPCIÓN
            </th>
            <th
              class="table_letra"
              style="background-color: #a21c26; color: #fff"
            >
              CLASIFICACIÓN
            </th>
            <th
              class="table_letra"
              style="background-color: #cc631d; color: #fff"
            >
              FUENTE
            </th>
            <th
              class="table_letra"
              style="background-color: #cc631d; color: #fff"
            >
              MEDIO
            </th>
            <th
              class="table_letra"
              style="background-color: #cc631d; color: #fff"
            >
              INDIVIDUO
            </th>
            <th
              class="table_letra"
              style="background-color: #eec425; color: #000"
            >
              NIVEL DE DEFICIENCIA
            </th>
            <th
              class="table_letra"
              style="background-color: #eec425; color: #000"
            >
              NIVEL DE EXPOSICIÓN
            </th>
            <th
              class="table_letra"
              style="background-color: #eec425; color: #000"
            >
              NIVEL DE PROBABILIDAD
            </th>
            <th
              class="table_letra"
              style="background-color: #eec425; color: #000"
            >
              INTERPRETACIÓN DEL NIVEL DE PROBABILIDAD
            </th>
            <th
              class="table_letra"
              style="background-color: #eec425; color: #000"
            >
              NIVEL DE CONSECUENCIA
            </th>
            <th
              class="table_letra"
              style="background-color: #eec425; color: #000"
            >
              NIVEL DE RIESGO (NR) E INTERVENCIÓN
            </th>
            <th
              class="table_letra"
              style="background-color: #eec425; color: #000"
            >
              INTERPRETACIÓN DEL NR
            </th>
            <th
              class="table_letra"
              style="background-color: #d9d9d9; color: #000"
            >
              ACEPTABILIDAD DEL RIESGO
            </th>
            <th
              class="table_letra"
              style="background-color: #cc631d; color: #fff"
            >
              Nº EXPUESTOS
            </th>
            <th
              class="table_letra"
              style="background-color: #cc631d; color: #fff"
            >
              PEOR CONSECUENCIA
            </th>
            <th
              class="table_letra"
              style="background-color: #d98530; color: #fff"
            >
              ELIMINACIÓN
            </th>
            <th
              class="table_letra"
              style="background-color: #d98530; color: #fff"
            >
              SUSTITUCIÓN
            </th>
            <th
              class="table_letra"
              style="background-color: #d98530; color: #fff"
            >
              CONTROLES DE INGENIERÍA
            </th>
            <th
              class="table_letra"
              style="background-color: #d98530; color: #fff"
            >
              CONTROLES ADMINISTRATIVOS, SEÑALIZACIÓN, ADVERTENCIA
            </th>
            <th
              class="table_letra col-7"
              style="background-color: #d98530; color: #fff"
            >
              EQUIPOS/ELEMENTOS DE PROTECCIÓN PERSONAL
            </th>
          </tr>
        </thead>
        <tbody class="colorTabla">
          <tr
            v-for="(usuario, index) of array_lista_peligros"
            :key="index.usuario"
            style="max-height: 250px !important"
          >
            <td style="background-color: #f2f2f2">
              <div class="height-columns overflow-auto">
                {{ usuario.proceso_riesgo }}
              </div>
            </td>
            <td style="background-color: #f2f2f2; font-weight: bold">
              <div class="height-columns overflow-auto">{{ usuario.zona }}</div>
            </td>
            <td style="background-color: #f2f2f2">
              <div class="height-columns overflow-auto">
                {{ usuario.actividades }}
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                <div v-if="!Array.isArray(usuario.tareas)">
                  {{ usuario.tareas }}
                </div>
                <div
                  v-else
                  class="table-borderless"
                  v-for="(u_tarea, index) of usuario.tareas"
                  :key="index.u_tarea"
                >
                  <span class="badge badge-info">{{ index + 1 }}</span>
                  {{ u_tarea }}
                </div>
              </div>
            </td>
            <td>
              <div
                class="height-columns overflow-auto"
                style="text-align: center !important"
              >
                <div v-if="usuario.rutinario == true">Si</div>
                <div v-else>No</div>
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                {{ usuario.descripcion }}
              </div>
            </td>
            <td>
              <div
                style="font-weight: bold"
                class="height-columns overflow-auto"
              >
                <div
                  v-if="
                    usuario.clasificacion != '' ||
                    usuario.clasificacion != undefined
                  "
                >
                  {{ usuario.clasificacion }}
                </div>
                <div v-if="usuario.tipo">
                  {{ usuario.tipo }}
                </div>
                <div v-if="usuario.subti">
                  {{ usuario.subti }}
                </div>
                <div v-if="usuario.otro_subti">
                  {{ usuario.otro_subti }}
                </div>
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                <div v-for="efecto in usuario.efectos" :key="efecto">
                  <p v-if="efecto != ''">{{ efecto }}</p>
                </div>
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                <div v-for="fuente in usuario.control_fuente" :key="fuente">
                  <p v-if="fuente != ''">{{ fuente }}</p>
                </div>
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                <div v-for="medio in usuario.control_medio" :key="medio">
                  <p v-if="medio != ''">{{ medio }}</p>
                </div>
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                <div
                  v-for="individuo in usuario.control_individuo"
                  :key="individuo"
                >
                  <p v-if="individuo != ''">{{ individuo }}</p>
                </div>
              </div>
            </td>
            <td>
              <div
                class="height-columns overflow-auto"
                style="text-align: center !important"
              >
                {{ usuario.nivel_eficiencia }}
              </div>
            </td>
            <td>
              <div
                class="height-columns overflow-auto"
                style="text-align: center !important"
              >
                {{ usuario.nivel_exposicion }}
              </div>
            </td>
            <td>
              <div
                class="height-columns overflow-auto"
                style="text-align: center !important"
              >
                {{ usuario.nivel_probabilidad }}
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                <center>
                  <div
                    v-if="usuario.interpretacion != ''"
                    :class="usuario.class_btn_outline"
                    style="width: 85px"
                  >
                    {{ usuario.interpretacion }}
                  </div>
                </center>
              </div>
            </td>
            <td>
              <div
                class="height-columns overflow-auto"
                style="text-align: center !important"
              >
                {{ usuario.nivel_consecuencia }}
              </div>
            </td>
            <td>
              <div
                class="height-columns overflow-auto"
                style="text-align: center !important"
              >
                {{ usuario.nivel_riesgo }}
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                <center>
                  <div
                    v-if="usuario.interpretacion_nr != ''"
                    class="btn btn-outline-primary"
                    readonly
                    style="width: 85px"
                  >
                    {{ usuario.interpretacion_nr }}
                  </div>
                </center>
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                <div
                  v-if="usuario.aceptabilidad != ''"
                  :class="usuario.class_btn_alerts"
                  readonly
                  value=""
                >
                  {{ usuario.aceptabilidad }}
                </div>
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                {{ usuario.num_expuestos }}
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                {{ usuario.peor_consecuencia }}
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                <div v-if="!Array.isArray(usuario.eliminacion)">
                  {{ usuario.eliminacion }}
                </div>
                <div
                  v-else
                  class="table-borderless"
                  v-for="(u_eli, index) of usuario.eliminacion"
                  :key="index.u_eli"
                >
                  <span class="badge badge-info">{{ index + 1 }}</span>
                  {{ u_eli }}
                </div>
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                <div v-if="!Array.isArray(usuario.sustitucion)">
                  {{ usuario.sustitucion }}
                </div>
                <div
                  v-else
                  class="table-borderless"
                  v-for="(u_susti, index) of usuario.sustitucion"
                  :key="index.u_susti"
                >
                  <span class="badge badge-info">{{ index + 1 }}</span>
                  {{ u_susti }}
                </div>
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                <div v-if="!Array.isArray(usuario.controles_ing)">
                  {{ usuario.controles_ing }}
                </div>
                <div
                  v-else
                  class="table-borderless"
                  v-for="(u_ctring, index) of usuario.controles_ing"
                  :key="index.u_ctring"
                >
                  <span class="badge badge-info">{{ index + 1 }}</span>
                  {{ u_ctring }}
                </div>
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                <div v-if="!Array.isArray(usuario.controles)">
                  {{ usuario.controles }}
                </div>
                <div
                  v-else
                  class="table-borderless"
                  v-for="(u_ctr, index) of usuario.controles"
                  :key="index.u_ctr"
                >
                  <span class="badge badge-info">{{ index + 1 }}</span>
                  {{ u_ctr }}
                </div>
              </div>
            </td>
            <td>
              <div class="height-columns overflow-auto">
                <div v-if="!Array.isArray(usuario.equipos)">
                  {{ usuario.equipos }}
                </div>
                <div
                  v-else
                  class="table-borderless"
                  v-for="(u_equipo, index) of usuario.equipos"
                  :key="index.u_equipo"
                >
                  <span class="badge badge-info">{{ index + 1 }}</span>
                  {{ u_equipo }}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- MODAL COPIAR URL -->
    <div
      class="modal fade"
      id="modal_url"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Compartir por Código QR
                    </button>
                  </h2>
                </div>

                <div
                  id="collapseOne"
                  class="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <center>
                      <div id="qrcode"></div>
                    </center>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingTwo">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Compatir por link
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseTwo"
                  class="collapse"
                  aria-labelledby="headingTwo"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <div class="form-group">
                      <label for="url_matriz"
                        >Copia el URL para compartir tu matriz</label
                      >
                      <input
                        type="text"
                        class="form-control rounded-pill mb-2"
                        v-model="url_matriz"
                        id="url_matriz"
                      /><br />
                      <a
                        class="btn btn-outline-secondary rounded-pill"
                        @click="copiar_url()"
                        ><i class="far fa-clone"></i>Copiar URL</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL MOSTRAR MATRIZ -->
    <div
      class="modal fade"
      id="modal_mostrar_matriz"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-11">
                <h1
                  style="
                    text-align: center !important;
                    color: #878787;
                    font-size: 3.5vh;
                  "
                >
                  MATRIZ DE IDENTIFICACIÓN DE PELIGROS, EVALUACIÓN Y VALORACIÓN
                  DE RIESGOS.
                </h1>
              </div>
              <div class="col-md-1">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>

            <div class="table-responsive" id="div1">
              <table
                class="table_excel"
                bgcolor="#DADADA"
                FRAME="void"
                RULES="all"
                id="myTable"
              >
                <thead>
                  <tr>
                    <td style="height: 15px"></td>
                  </tr>
                  <tr>
                    <th style="background: #c6c6c6">Nombre de la Empresa:</th>
                    <td colspan="2">{{ cliente_empresa.c_empresa }}</td>
                    <th style="background: #c6c6c6" colspan="3">
                      Actividad Económica:
                    </th>
                    <td colspan="2">{{ cliente_empresa.c_actividad }}</td>
                    <th style="background: #c6c6c6" colspan="3">
                      Nombre del Centro de Trabajo:
                    </th>
                    <td colspan="3">{{ cliente_empresa.c_trabajo }}</td>
                    <th style="background: #c6c6c6">Ciudad:</th>
                    <td colspan="2">{{ cliente_empresa.c_ciudad }}</td>
                    <th style="background: #c6c6c6">Departamento:</th>
                    <td>{{ cliente_empresa.c_departamento }}</td>
                  </tr>
                  <tr>
                    <th style="background: #c6c6c6">Número de Trabajadores</th>
                    <td colspan="2">
                      {{ cliente_empresa.c_num_trabajadores }}
                    </td>
                    <th style="background: #c6c6c6" colspan="3">
                      Clase de Riesgo:
                    </th>
                    <td colspan="2">
                      <div
                        v-for="(
                          clase_riesgo, index
                        ) of cliente_empresa.c_clase_riesgo"
                        :key="index"
                      >
                        <template v-if="cliente_empresa.c_clase_riesgo">{{
                          clase_riesgo
                        }}</template>
                      </div>
                    </td>
                    <th style="background: #c6c6c6" colspan="3">
                      Fecha Actualización:
                    </th>
                    <td colspan="3">{{ cliente_empresa.c_fecha }}</td>
                    <th style="background: #c6c6c6">Responsable empresa:</th>
                    <td colspan="2">{{ cliente_empresa.c_responsable }}</td>
                    <th style="background: #c6c6c6">Visita atendida por:</th>
                    <td>{{ cliente_empresa.c_visita }}</td>
                  </tr>
                  <tr>
                    <td style="height: 15px" colspan="10"></td>
                  </tr>

                  <tr>
                    <th
                      rowspan="2"
                      class="table_letra"
                      style="background-color: #85c1e9"
                    >
                      PROCESO
                    </th>
                    <th
                      rowspan="2"
                      class="table_letra"
                      style="background-color: #85c1e9"
                    >
                      ZONA/LUGAR
                    </th>
                    <th
                      rowspan="2"
                      class="table_letra"
                      style="background-color: #85c1e9"
                    >
                      ACTIVIDADES
                    </th>
                    <th
                      rowspan="2"
                      class="table_letra"
                      style="background-color: #85c1e9"
                    >
                      TAREAS
                    </th>
                    <th
                      rowspan="2"
                      class="table_letra"
                      style="background-color: #85c1e9"
                    >
                      TAREA RUTINARIO (SI O NO)
                    </th>
                    <th
                      colspan="2"
                      class="table_letra"
                      style="background-color: #f1948a"
                    >
                      PELIGRO
                    </th>
                    <th
                      rowspan="2"
                      class="table_letra"
                      style="background-color: #82e0aa"
                    >
                      EFECTOS POSIBLES
                    </th>
                    <th
                      colspan="3"
                      class="table_letra"
                      style="background-color: #eb984e"
                    >
                      CONTROLES EXISTENTES
                    </th>
                    <th
                      colspan="7"
                      class="table_letra"
                      style="background-color: #99a3a4"
                    >
                      EVALUACIÓN DEL RIESGO
                    </th>
                    <th
                      colspan="1"
                      class="table_letra"
                      style="background-color: #aed6f1"
                    >
                      VALORACIÓN DEL RIESGO
                    </th>
                    <th
                      colspan="2"
                      class="table_letra"
                      style="background-color: #d699cb"
                    >
                      CRITERIOS PARA ESTABLECER CONTROLES
                    </th>
                    <th
                      colspan="5"
                      class="table_letra"
                      style="background-color: #f5b041"
                    >
                      MEDIDAS DE INTERVENCIÓN
                    </th>
                  </tr>
                  <tr>
                    <th class="table_letra" style="background-color: #f1948a">
                      DESCRIPCIÓN
                    </th>
                    <th class="table_letra" style="background-color: #f1948a">
                      CLASIFICACIÓN
                    </th>
                    <th class="table_letra" style="background-color: #eb984e">
                      FUENTE
                    </th>
                    <th class="table_letra" style="background-color: #eb984e">
                      MEDIO
                    </th>
                    <th class="table_letra" style="background-color: #eb984e">
                      INDIVIDUO
                    </th>
                    <th class="table_letra" style="background-color: #99a3a4">
                      NIVEL DE DEFICIENCIA
                    </th>
                    <th class="table_letra" style="background-color: #99a3a4">
                      NIVEL DE EXPOSICIÓN
                    </th>
                    <th class="table_letra" style="background-color: #99a3a4">
                      NIVEL DE PROBABILIDAD
                    </th>
                    <th class="table_letra" style="background-color: #99a3a4">
                      INTERPRETACIÓN DEL NIVEL DE PROBABILIDAD
                    </th>
                    <th class="table_letra" style="background-color: #99a3a4">
                      NIVEL DE CONSECUENCIA
                    </th>
                    <th class="table_letra" style="background-color: #99a3a4">
                      NIVEL DE RIESGO (NR) E INTERVENCIÓN
                    </th>
                    <th class="table_letra" style="background-color: #99a3a4">
                      INTERPRETACIÓN DEL NR
                    </th>
                    <th class="table_letra" style="background-color: #aed6f1">
                      ACEPTABILIDAD DEL RIESGO
                    </th>
                    <th class="table_letra" style="background-color: #d699cb">
                      Nº EXPUESTOS
                    </th>
                    <th class="table_letra" style="background-color: #d699cb">
                      PEOR CONSECUENCIA
                    </th>
                    <th class="table_letra" style="background-color: #f5b041">
                      ELIMINACIÓN
                    </th>
                    <th class="table_letra" style="background-color: #f5b041">
                      SUSTITUCIÓN
                    </th>
                    <th class="table_letra" style="background-color: #f5b041">
                      CONTROLES DE INGENIERÍA
                    </th>
                    <th class="table_letra" style="background-color: #f5b041">
                      CONTROLES ADMINISTRATIVOS, SEÑALIZACIÓN, ADVERTENCIA
                    </th>
                    <th
                      class="table_letra col-7"
                      style="background-color: #f5b041"
                    >
                      EQUIPOS/ELEMENTOS DE PROTECCIÓN PERSONAL
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(usuario, index) of array_lista_peligros"
                    :key="index.uusario"
                    style="text-align: center"
                  >
                    <td>{{ usuario.proceso_riesgo }}</td>
                    <td>{{ usuario.zona }}</td>
                    <td>{{ usuario.actividades }}</td>
                    <td>
                      <div v-if="!Array.isArray(usuario.tareas)">
                        {{ usuario.tareas }}
                      </div>
                      <div
                        v-else
                        class="table-borderless justify-content-start"
                        v-for="(u_tarea, index) of usuario.tareas"
                        :key="index.u_tarea"
                      >
                        <span class="badge badge-info">{{ index + 1 }}</span>
                        {{ u_tarea }}
                      </div>
                    </td>
                    <td>
                      <div v-if="usuario.rutinario == true">Si</div>
                      <div v-else>No</div>
                    </td>
                    <td>{{ usuario.descripcion }}</td>
                    <td>
                      <div
                        v-if="
                          usuario.clasificacion != '' ||
                          usuario.clasificacion != undefined
                        "
                      >
                        {{ usuario.clasificacion }}
                      </div>
                      <div v-if="usuario.tipo">
                        {{ usuario.tipo }}
                      </div>
                      <div v-if="usuario.subti">
                        {{ usuario.subti }}
                      </div>
                      <div v-if="usuario.otro_subti">
                        {{ usuario.otro_subti }}
                      </div>
                    </td>
                    <td>
                      <div v-for="efecto in usuario.efectos" :key="efecto">
                        <p v-if="efecto != ''">{{ efecto }}</p>
                      </div>
                    </td>
                    <td>
                      <div
                        v-for="fuente in usuario.control_fuente"
                        :key="fuente"
                      >
                        <p v-if="fuente != ''">{{ fuente }}</p>
                      </div>
                    </td>
                    <td>
                      <div v-for="medio in usuario.control_medio" :key="medio">
                        <p v-if="medio != ''">{{ medio }}</p>
                      </div>
                    </td>
                    <td>
                      <div
                        v-for="individuo in usuario.control_individuo"
                        :key="individuo"
                      >
                        <p v-if="individuo != ''">{{ individuo }}</p>
                      </div>
                    </td>
                    <td>{{ usuario.nivel_eficiencia }}</td>
                    <td>{{ usuario.nivel_exposicion }}</td>
                    <td>{{ usuario.nivel_probabilidad }}</td>
                    <td>
                      <center>
                        <div
                          v-if="usuario.interpretacion != ''"
                          :class="usuario.class_btn_outline"
                          style="width: 85px"
                        >
                          {{ usuario.interpretacion }}
                        </div>
                      </center>
                    </td>
                    <td>{{ usuario.nivel_consecuencia }}</td>
                    <td>{{ usuario.nivel_riesgo }}</td>
                    <td>
                      <center>
                        <div
                          v-if="usuario.interpretacion_nr != ''"
                          class="btn btn-outline-primary"
                          readonly
                          style="width: 85px"
                        >
                          {{ usuario.interpretacion_nr }}
                        </div>
                      </center>
                    </td>
                    <td>
                      <div
                        v-if="usuario.aceptabilidad != ''"
                        :class="usuario.class_btn_alerts"
                        readonly
                        value=""
                      >
                        {{ usuario.aceptabilidad }}
                      </div>
                    </td>
                    <td>{{ usuario.num_expuestos }}</td>
                    <td>{{ usuario.peor_consecuencia }}</td>
                    <td>
                      <div v-if="!Array.isArray(usuario.eliminacion)">
                        {{ usuario.eliminacion }}
                      </div>
                      <div
                        v-else
                        class="table-borderless justify-content-start"
                        v-for="(u_eli, index) of usuario.eliminacion"
                        :key="index.u_eli"
                      >
                        <span class="badge badge-info">{{ index + 1 }}</span>
                        {{ u_eli }}
                      </div>
                    </td>
                    <td>
                      <div v-if="!Array.isArray(usuario.sustitucion)">
                        {{ usuario.sustitucion }}
                      </div>
                      <div
                        v-else
                        class="table-borderless justify-content-start"
                        v-for="(u_susti, index) of usuario.sustitucion"
                        :key="index.u_susti"
                      >
                        <span class="badge badge-info">{{ index + 1 }}</span>
                        {{ u_susti }}
                      </div>
                    </td>
                    <td>
                      <div v-if="!Array.isArray(usuario.controles_ing)">
                        {{ usuario.controles_ing }}
                      </div>
                      <div
                        v-else
                        class="table-borderless justify-content-start"
                        v-for="(u_ctring, index) of usuario.controles_ing"
                        :key="index.u_ctring"
                      >
                        <span class="badge badge-info">{{ index + 1 }}</span>
                        {{ u_ctring }}
                      </div>
                    </td>
                    <td>
                      <div v-if="!Array.isArray(usuario.controles)">
                        {{ usuario.controles }}
                      </div>
                      <div
                        v-else
                        class="table-borderless justify-content-start"
                        v-for="(u_ctr, index) of usuario.controles"
                        :key="index.u_ctr"
                      >
                        <span class="badge badge-info">{{ index + 1 }}</span>
                        {{ u_ctr }}
                      </div>
                    </td>
                    <td>
                      <div v-if="!Array.isArray(usuario.equipos)">
                        {{ usuario.equipos }}
                      </div>
                      <div
                        v-else
                        class="table-borderless justify-content-start"
                        v-for="(u_equipo, index) of usuario.equipos"
                        :key="index.u_equipo"
                      >
                        <span class="badge badge-info">{{ index + 1 }}</span>
                        {{ u_equipo }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <!--button @click='proceso_copiar_matriz' type="button" class="btn boton_guardar">
                            Copiar Matriz
                        </button-->
            <a
              href="#"
              id="test"
              type="button"
              class="btn boton_guardar"
              @click="fnExcelReport()"
              >Descargar Excel</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL PROCESO COPIAR -->

    <!-- MODAL DE AGREGAR PROCESO NUEVO DE COPIADO DE MATRIZ -->
    <div
      v-if="$store.state.user_auth"
      class="modal fade"
      id="modal_reg_proceso"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl"
        role="document"
      >
        <div class="modal-content" style="border-radius: 8px">
          <div
            class="modal-header border-bottom-0 d-flex justify-content-center"
          >
            <button
              type="button"
              class="btn m-1 bg-light rounded-pill"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                style="
                  color: #ee8813;
                  font-weight: bold;
                  text-alig: center;
                  font-size: 2rem;
                "
                aria-hidden="true"
                >X</span
              >
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="box-body bg-light matriz-peligro-content col-md-12">
              <form v-on:submit.prevent="agregar_centro_trabajo()">
                <div class="row justify-content-center">
                  <div class="col-md-3">
                    <label class="color_letra mt-3"
                      >Cliente: *<span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title="Seleccione uno de los clientes con el vinculará la matriz de peligros"
                        ></i></span
                    ></label>
                    <v-select
                      class="form-control form-control-sm boton_texto"
                      @input="consultar_clientes_por_nombre"
                      v-model="cliente"
                      :options="clientes_iper"
                      required
                    ></v-select>
                  </div>
                  <div class="col-md-4">
                    <label class="color_letra mt-3"
                      >Grupo de Exposicion Similar: *<span
                        class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title="El grupo de exposición similar es la agrupación de los clientes de acuerdo a su actividad económica principal"
                        ></i></span
                    ></label>
                    <input
                      v-model="sector_cliente"
                      type="text"
                      class="form-control form-control-sm boton_texto"
                      required
                      disabled
                    />
                  </div>
                  <div class="col-md-3">
                    <label class="color_letra mt-3"
                      >Nombre del Centro de Trabajo: *<span
                        class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title="Indique el nombre del centro de trabajo al que va a realizar la matriz de peligros"
                        ></i></span
                    ></label>
                    <input
                      v-model="centro_trabajo"
                      type="text"
                      class="form-control form-control-sm boton_texto"
                      placeholder="Nombre del Centro de Trabajo."
                      required
                    />
                  </div>
                  <div class="col-md-2">
                    <label class="color_letra mt-3"
                      >N° Expuestos: *<span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title="Indique a continuación el número de trabajadores objeto de la presente matriz de peligros, incluir trabajadores que están en descanso y/u otros turnos"
                        ></i></span
                    ></label>
                    <input
                      v-model="numero_expuestos"
                      type="number"
                      min="0"
                      class="form-control form-control-sm boton_texto"
                      placeholder="N° de Expuestos."
                      required
                    />
                  </div>
                  <div class="col-md-2">
                    <label class="color_letra mt-3"
                      >Regional: *<span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title="Seleccione a continuación la regional a la que pertenece el centro de trabajo"
                        ></i></span
                    ></label>
                    <select
                      v-model="regional"
                      @change="departamento_select()"
                      id="regional"
                      class="form-control form-control-sm boton_texto"
                      required
                    >
                      <option value="" selected disabled>
                        Seleccione la Regional
                      </option>
                      <option v-for="reg of lista_regionales" :key="reg">
                        {{ reg }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <label class="color_letra mt-3"
                      >Departamento: *<span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title="Seleccione a continuación el departamento al que pertenece el centro de trabajo"
                        ></i></span
                    ></label>
                    <select
                      v-model="departamento"
                      @change="municipio_select()"
                      id="departamento"
                      class="form-control form-control-sm boton_texto"
                      required
                    >
                      <option value="" selected disabled>
                        Seleccione el departamento
                      </option>
                      <option v-for="dept of lista_departamentos" :key="dept">
                        {{ dept }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <label class="color_letra mt-3"
                      >Ciudad/Municipio: *<span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title="Seleccione a continuación la ciudad o muncipio al que pertencece el centro de trabajo"
                        ></i></span
                    ></label>
                    <select
                      v-model="municipio"
                      id="ciudad"
                      class="form-control form-control-sm boton_texto"
                      required
                    >
                      <option value="" selected disabled>
                        Seleccione la ciudad
                      </option>
                      <option
                        v-for="municipio of lista_municipios"
                        :key="municipio"
                      >
                        {{ municipio }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <label class="color_letra mt-3"
                      >Dirección:
                      <span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title="Relaciona a continuación la dirección donde se ubica el centro de trabajo"
                        ></i></span
                    ></label>
                    <input
                      v-model="direccion"
                      type="text"
                      min="1"
                      class="form-control form-control-sm boton_texto"
                      placeholder="Dirección del centro de trabajo"
                    />
                  </div>
                  <div class="col-md-4 col-12 form-group">
                    <label class="color_letra mt-3"
                      ><b>Ubicación GPS de la Residencia Actual</b></label
                    >
                    <br />
                    <div class="row">
                      <div class="col-sm-2">
                        <button
                          class="btn gps btn-sm mb-1"
                          type="button"
                          @click="obtener_ubicacion"
                        >
                          Obtener
                        </button>
                      </div>
                      <div class="col-sm-10">
                        <input
                          type="text"
                          class="form-control form-control-sm form-control form-control-sm-sm boton_texto"
                          v-model="coordenadas_encuesta"
                          readonly
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="color_letra mt-3"
                      >Contacto del Centro de Trabajo: *<span
                        class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title="Relaciona a continuación la persona contacto o representante de la empresa en el centro de trabajo con quien se coordinó la actividad de la matriz de peligros"
                        ></i></span
                    ></label>
                    <input
                      v-model="nombre_contacto"
                      type="text"
                      class="form-control form-control-sm boton_texto"
                      placeholder="Nombre de la persona."
                      required
                    />
                  </div>
                  <div class="col-md-2">
                    <label class="color_letra mt-3"
                      >Cargo: *<span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title="Relacione a continuación el cargo de la persona contacto con quien se coordinó la actividad de la matriz de peligros"
                        ></i></span
                    ></label>
                    <input
                      v-model="cargo_contacto"
                      type="text"
                      class="form-control form-control-sm boton_texto"
                      placeholder="Cargo de la persona."
                      onchange="value=toTitleCase(this.value)"
                      onkeyup="value=toTitleCase(this.value)"
                      required
                    />
                  </div>
                  <div class="col-md-3">
                    <label class="color_letra mt-3"
                      >Correo Electrónico: *<span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title="Relacione a continuación el correo del contacto del centro de trabajo con quien se coordinó la actividad de matriz de peligros"
                        ></i></span
                    ></label>
                    <input
                      v-model="correo_contacto"
                      type="email"
                      class="form-control form-control-sm boton_texto"
                      placeholder="Correo electrónico."
                      required
                    />
                  </div>
                  <div class="col-md-2">
                    <label class="color_letra mt-3"
                      >Celular/Teléfono: *<span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title="Relacione a continuación un numero telefónico del contacto del centro de trabajo con quien se coordino la actividad de matriz de peligros"
                        ></i></span
                    ></label>
                    <input
                      v-model="numero_contacto"
                      type="number"
                      min="1"
                      class="form-control form-control-sm boton_texto"
                      placeholder="Celular o teléfono."
                      required
                    />
                  </div>
                </div>
                <br />
                <div class="col-md-6">
                  <label class="color_letra mt-3">* Campos Obligatorios.</label>
                </div>
                <div class="row justify-content-center">
                  <button
                    type="submit"
                    class="btn btn-sm btn-form font-weight-bold"
                    :disabled="!priv_crear"
                  >
                    GUARDAR
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div v-if="$store.state.g_compartir_matriz == ''">
      <div class="container p-5">
        <div class="alert alert-dark" role="alert">¡Esta matriz no existe!</div>
      </div>
    </div>
    <div v-else class="container p-5">
      <div class="alert alert-dark" role="alert">
        ¡El usuario ha dejado de compartir esta matriz!
      </div>
    </div>
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "./../firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "qmatriz",
  data() {
    return {
      id_cliente: this.$route.params.id,

      array_lista_peligros: [],
      id_cliente_matriz: "",

      // ARRAY TEMPORAL DE LISTA PROCESOS, EFECTOS, FUENTE, MEDIO, INDIVIDUO
      arr_temp_procesos: [],

      cargar_procesos: false,

      cliente_empresa: {},

      nombre_cliente: "",
      copiar_matriz: false,

      //-------- VARIABLES COPIADO DE MATRIZ --------//
      cliente: "",
      sector_cliente: "",
      id_cliente_iper: "",
      centro_trabajo: "",
      numero_expuestos: null,
      regional: "",
      pais_trabajo: "Colombia",
      departamento: "",
      municipio: "",
      nombre_contacto: "",
      cargo_contacto: "",
      correo_contacto: "",
      numero_contacto: "",
      fecha_actual: "",

      direccion: "",

      clientes_iper: [],

      lista_regionales: [],
      lista_departamentos: [],
      lista_municipios: [],
      priv_crear: false,

      latitud_encuesta: "",
      longitud_encuesta: "",
      coordenadas_encuesta: "",

      //-------- MOSTRAR URL DEL SITIO --------//
      url_matriz: "",
      idMatriz: "",
      download_matriz: false,
      // VARIABLES PARA CONSULTAR EL LOGO DE LA EMPRESA
      nit_logo: "",
      logo_cliente: "",

      //-------- VARIABLES COPIADO DE MATRIZ --------//
      id_matriz: "",
      id_copiar_matriz: false,
      array_nuevo_peligros: [],

      cliente: "",
      sector_cliente: "",
      id_cliente_iper: "",
      centro_trabajo: "",
      numero_expuestos: null,
      regional: "",
      pais_trabajo: "Colombia",
      departamento: "",
      municipio: "",
      nombre_contacto: "",
      cargo_contacto: "",
      correo_contacto: "",
      numero_contacto: "",
      fecha_actual: "",

      direccion: "",

      clientes_iper: [],

      lista_regionales: [],
      lista_departamentos: [],
      lista_municipios: [],
      priv_crear: false,

      latitud_encuesta: "",
      longitud_encuesta: "",
      coordenadas_encuesta: "",
    };
  },
  watch: {
    $route(to) {
      this.id_cliente = to.params.id;
    },
  },
  created() {
    this.url_matriz = this.id_cliente;
    this.descargarExcelConsulta();

    //-------- VARIABLES PARA EL COPIADO DE MATRIZ <-NUEVO PROCESO-> --------//
    // VARIABLE THIS LISTA CLIENTES
    this.cargar_clientes();
    this.regional_select();
    if (this.$store.state.global_privilegio_matriz_peligro.crear) {
      this.priv_crear = true;
    }
    this.nombre_contacto = "Ángela Johana Gaitán López";
    this.cargo_contacto = "Gerente H&S";
    this.correo_contacto = "angela.gaitan@co.g4s.com";
    this.numero_contacto = 3212543320;
    this.fecha_hoy();
    var today = new Date();
    var dd = today.getDate();

    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + yyyy;
    //-------- VARIABLES PARA EL COPIADO DE MATRIZ <-NUEVO PROCESO-> --------//
  },
  methods: {
    // NUEVAS FUNCIONES DESCARGAR EXCEL
    async descargarExcelConsulta() {
      NProgress.start();
      await this.ver_matriz();
      let consultarClienteEmpresa = await this.consultarClienteEmpresa(
        this.id_cliente
      );
      let existenciaPeligros = await this.existenciaPeligros(this.id_cliente);
      let excelProcesoConsulta = await this.excelProcesoConsulta(
        this.id_cliente
      );
      let excelZonaConsulta = await this.excelZonaConsulta(this.id_cliente);
      let excelActividadConsulta = await this.excelActividadConsulta(
        this.id_cliente
      );
      let excelTareasConsulta = await this.excelTareasConsulta(this.id_cliente);
      let excelMatrizFinal = await this.excelMatrizFinal(
        excelProcesoConsulta,
        excelZonaConsulta,
        excelActividadConsulta,
        excelTareasConsulta
      );
      if (this.download_matriz == true) {
        let descargarExcelFinal = await this.descargarExcelFinal();
      }
      NProgress.done();
      NProgress.remove();
    },

    async consultarClienteEmpresa(id_cliente) {
      let queryClienteEmpresa = db
        .collection("cliente_empresa")
        .doc(id_cliente);
      await queryClienteEmpresa.get().then((doc) => {
        if (doc.exists) {
          this.cliente_empresa.c_empresa = `${doc.data().em_empresa}`;
          this.cliente_empresa.c_sector = `${doc.data().em_sector}`;
          if (doc.data().em_actividad) {
            this.cliente_empresa.c_actividad = doc.data().em_actividad;
          } else {
            this.cliente_empresa.c_actividad = doc.data().em_sector;
          }
          let arr = [];
          if (doc.data().em_clase_riesgo) arr.push(doc.data().em_clase_riesgo);
          if (doc.data().em_clase_riesgo1)
            arr.push(doc.data().em_clase_riesgo1);
          if (doc.data().em_clase_riesgo2)
            arr.push(doc.data().em_clase_riesgo2);
          if (doc.data().em_clase_riesgo3)
            arr.push(doc.data().em_clase_riesgo3);
          if (doc.data().em_clase_riesgo4)
            arr.push(doc.data().em_clase_riesgo4);

          this.cliente_empresa.c_clase_riesgo = arr;
          this.consultarLogo(`${doc.data().em_nit}`);
          this.cliente_empresa.c_nit = `${doc.data().em_nit}`;
          this.cliente_empresa.c_trabajo = `${doc.data().em_trabajo}`;
          this.cliente_empresa.c_pais = `${doc.data().em_pais}`;
          this.cliente_empresa.c_departamento = `${doc.data().em_departamento}`;
          this.cliente_empresa.c_ciudad = `${doc.data().em_ciudad}`;
          this.cliente_empresa.c_num_trabajadores = `${
            doc.data().em_num_trabajadores
          }`;
          if (`${doc.data().em_fecha}`.slice(0, 1) === "T") {
            this.cliente_empresa.c_fecha = `${doc.data().em_fecha.toDate()}`;
          } else {
            this.cliente_empresa.c_fecha = `${doc.data().em_fecha}`;
          }
          this.cliente_empresa.c_responsable = `${doc.data().em_responsable}`;
          if (doc.data().em_visita)
            this.cliente_empresa.c_visita = doc.data().em_visita;
          else this.cliente_empresa.c_visita = "";
          this.cliente_empresa.c_baja = `${doc.data().em_baja}`;
          this.cliente_empresa.c_evaluacion = `${doc.data().em_evaluacion}`;

          this.array_lista_peligros = [];
          this.id_cliente_matriz = `${id_cliente}`;
        } else {
          NProgress.done();
          NProgress.remove();
        }
      });
    },

    async existenciaPeligros(id_cliente) {
      let queryPeligros = db
        .collection("matriz_riesgo")
        .where("em_id_cliente", "==", id_cliente);
      queryPeligros.get().then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          this.es_peligros = true;
        } else {
          Swal.fire({
            icon: "error",
            title: "No hay peligros ingresados",
            text:
              "Si desea diligenciarlos, por favor en opciones del Centro de Trabajo seleccione 'Editar'",
          });
        }
      });
    },

    async excelProcesoConsulta(id_cliente) {
      let traerProcesos = db
        .collection("proceso")
        .where("em_id_cliente", "==", id_cliente)
        .get()
        .then((querySnapshot) => {
          let arrayExcelProcesos = [];
          if (querySnapshot.docs.length > 0) {
            querySnapshot.forEach((doc) => {
              arrayExcelProcesos.push({
                id_proceso: doc.id,
                em_proceso_riesgo: doc.data().em_proceso_riesgo,
              });
            });
            return arrayExcelProcesos;
          }
          // ESTO TAMBIÉN SE PUEDE QUITAR
          else {
            Swal.fire({
              icon: "error",
              title: "No hay Procesos ingresados",
              text:
                "Si desea diligenciarlos, por favor en opciones del Centro de Trabajo seleccione 'Editar'",
            });
            NProgress.done();
            NProgress.remove();
          }
          return arrayExcelProcesos;
        });
      return traerProcesos;
    },

    async excelZonaConsulta(id_cliente) {
      let traerZonas = db
        .collection("zona")
        .where("em_id_cliente", "==", id_cliente)
        .get()
        .then((querySnapshot) => {
          let arrayExcelZonas = [];
          querySnapshot.forEach((doc) => {
            arrayExcelZonas.push({
              id_proceso: doc.data().em_id_proceso,
              id_zona: doc.id,
              em_zona: doc.data().em_zona,
            });
          });
          return arrayExcelZonas;
        });
      return traerZonas;
    },

    async excelActividadConsulta(id_cliente) {
      let traerActividades = db
        .collection("actividades")
        .where("em_id_cliente", "==", id_cliente)
        .get()
        .then((querySnapshot) => {
          let arrayExcelActividades = [];
          querySnapshot.forEach((doc) => {
            arrayExcelActividades.push({
              id_proceso: doc.data().em_id_proceso,
              id_zona: doc.data().em_id_zona,
              id_actividad: doc.id,
              em_actividades: doc.data().em_actividades,
            });
          });
          return arrayExcelActividades;
        });
      return traerActividades;
    },

    async excelTareasConsulta(id_cliente) {
      let traerTarea = db
        .collection("tareas")
        .where("em_id_cliente", "==", id_cliente)
        .get()
        .then((querySnapshot) => {
          let arrayExcelTareas = [];
          querySnapshot.forEach((doc) => {
            if (this.es_peligros) {
              arrayExcelTareas.push({
                id_proceso: doc.data().em_id_proceso,
                id_zona: doc.data().em_id_zona,
                id_actividad: doc.data().em_id_acti,
                id_tarea: doc.id,
                em_tareas: doc.data().em_tareas,
              });
              return arrayExcelTareas;
            }
          });
          return arrayExcelTareas;
        });
      return traerTarea;
    },

    async excelMatrizFinal(
      excelProcesoConsulta,
      excelZonaConsulta,
      excelActividadConsulta,
      excelTareasConsulta
    ) {
      let arrayPeligros = [];
      excelTareasConsulta.forEach((tarea) => {
        let traerMatrizRiesgo = db
          .collection("matriz_riesgo")
          .where("em_id_tareas", "==", tarea.id_tarea);
        traerMatrizRiesgo.get().then((querySnapshot) => {
          if (querySnapshot.docs.length > 0) {
            querySnapshot.forEach((doc) => {
              let subti = "";
              let otro_subti = "";
              let eliminacion = "";
              let sustitucion = "";
              let controles_ing = "";
              let controles = "";
              let equipos = "";

              if (doc.data().em_subti) subti = doc.data().em_subti;
              if (doc.data().em_otro_subti)
                otro_subti = doc.data().em_otro_subti;
              if (doc.data().em_eliminacion)
                eliminacion = doc.data().em_eliminacion;
              if (doc.data().em_sustitucion)
                sustitucion = doc.data().em_sustitucion;
              if (doc.data().em_controles_ing)
                controles_ing = doc.data().em_controles_ing;
              else if (doc.data().em_control_ingenieria)
                controles_ing = doc.data().em_control_ingenieria;
              if (doc.data().em_controles) controles = doc.data().em_controles;
              else if (doc.data().em_controles_admin)
                equipos = doc.data().em_controles_admin;
              if (doc.data().em_equipos) equipos = doc.data().em_equipos;
              else if (doc.data().em_epp) equipos = doc.data().em_epp;

              let id_proceso = tarea.id_proceso;
              let proceso_riesgo = "";
              excelProcesoConsulta.forEach((proceso) => {
                if (proceso.id_proceso == id_proceso) {
                  proceso_riesgo = proceso.em_proceso_riesgo;
                }
              });
              let id_zona = tarea.id_zona;
              let zona = "";
              excelZonaConsulta.forEach((zona_q) => {
                if (zona_q.id_zona == id_zona) {
                  zona = zona_q.em_zona;
                }
              });
              let id_acti = tarea.id_actividad;
              let actividades = "";
              excelActividadConsulta.forEach((actividad) => {
                if (actividad.id_actividad == id_acti) {
                  actividades = actividad.em_actividades;
                }
              });
              let id_tareas = tarea.id_tarea;
              let tareas = tarea.em_tareas;
              this.array_lista_peligros.unshift({
                proceso_riesgo: proceso_riesgo,
                id_proceso: id_proceso,
                zona: zona,
                id_zona: id_zona,
                actividades: actividades,
                id_acti: id_acti,
                tareas: tareas,
                id_tarea: id_tareas,

                id_peligro: doc.data().em_id_peligro,
                id_subcla: doc.data().em_id_subclasificacion,
                id_efectos_posibles: doc.data().em_id_efectos_posibles,

                descripcion: `${doc.data().em_descripcion}`,
                clasificacion: `${doc.data().em_clasificacion}`,
                tipo: `${doc.data().em_tipo}`,
                rutinario: doc.data().em_rutinario,
                subti: subti,
                otro_subti: otro_subti,
                efectos: doc.data().em_efecto_posible,
                control_fuente: doc.data().em_c_fuente,
                control_medio: doc.data().em_c_medio,
                control_individuo: doc.data().em_c_individuo,

                nivel_eficiencia: doc.data().em_nivel_eficiencia,
                nivel_exposicion: doc.data().em_nivel_exposicion,
                nivel_probabilidad: doc.data().em_nivel_probabilidad,
                interpretacion: `${doc.data().em_interpretacion}`,
                nivel_consecuencia: doc.data().em_nivel_consecuencia,
                nivel_riesgo: doc.data().em_nivel_riesgo,
                interpretacion_nr: `${doc.data().em_interpretacion_nr}`,
                aceptabilidad: `${doc.data().em_aceptabilidad}`,

                num_expuestos: doc.data().em_num_expuestos,
                peor_consecuencia: `${doc.data().em_peor_consecuencia}`,

                eliminacion: eliminacion,
                sustitucion: sustitucion,
                controles_ing: controles_ing,
                controles: controles,
                equipos: equipos,

                class_btn_outline: "",
                class_btn_alerts: "",
              });
            });
          }
        });
      });
    },

    async descargarExcelFinal() {
      setTimeout(() => {
        const button = document.querySelector("#test");
        button.click();
        $("#modal_mostrar_matriz").modal("hide");
        this.download_matriz = false;
      }, 3000);
    },

    fnExcelReport() {
      var tab_text =
        '<html xmlns:o="urn:schemas-microsoft-com:office:excel" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40" <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">>';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Matriz de riesgo</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";

      // CÓDIGO PARA OBTENER LA TABLA HTML
      tab_text = tab_text + $("#myTable").html();
      tab_text = tab_text + "</table></body></html>";

      var data_type = 'data:application/vnd.ms-excel;base64"';

      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      // PARA INTERNET EXPLORER
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        if (window.navigator.msSaveBlob) {
          var blob = new Blob([tab_text], {
            type: "application/csv;",
          });
          navigator.msSaveBlob(blob, "Test file.xls");
        }
      }
      // PARA CHROME Y FIREFOX
      else {
        $("#test").attr(
          "href",
          data_type + ", " + encodeURIComponent(tab_text)
        );
        $("#test").attr("download", "Matriz Riesgo.xls");
      }
    },

    copiar_url() {
      var copyText = document.getElementById("url_matriz");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
    },

    ver_matriz() {
      db.collection("matriz_riesgo")
        .where("em_id_cliente", "==", this.id_cliente)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.idMatriz = doc.id;
            this.$store.state.g_compartir_matriz = doc.data().compartir_matriz;
            this.$store.state.g_descargar_matriz = doc.data().descargar_matriz;
          });
        });
    },

    mostrarUrl() {
      document.getElementById("qrcode").innerHTML = "";
      var qrcode = new QRCode(document.getElementById("qrcode"));
      qrcode.makeCode(this.url_matriz);
    },

    consultarLogo(nit_cliente) {
      db.collection("cliente_principal")
        .where("cl_nit_cliente", "==", nit_cliente)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.logo_cliente = `${doc.data().cl_logo}`;
          });
        });
    },

    //-------- PRIMER PASO COPIADO MATRIZ --------//
    // FUNCIÓN PARA AGREGAR MATRIZ DE PELIGROS A LA BASE DE DATOS
    agregar_centro_trabajo() {
      if (this.priv_crear) {
        var newCentroRef = db.collection("cliente_empresa").doc();
        var id = newCentroRef.id;
        let empresa = "G4S";
        (async () => {
          await NProgress.start();
          db.collection("cliente_empresa")
            .doc(id)
            .set({
              em_empresa: empresa,
              em_id_cliente_principal: this.id_cliente_iper,
              em_trabajo: this.centro_trabajo,
              em_num_trabajadores: this.numero_expuestos,
              em_sector: this.sector_cliente,
              em_pais: this.pais_trabajo,
              em_regional: this.regional,
              em_departamento: this.departamento,
              em_ciudad: this.municipio,

              em_registrado_por: this.$store.state.email_session,
              em_visita:
                this.$store.state.session_nombre +
                this.$store.state.session_apellido,

              em_fecha: firebase.firestore.FieldValue.serverTimestamp(),
              em_fecha_editado: firebase.firestore.FieldValue.serverTimestamp(),

              em_responsable: this.nombre_contacto,
              em_cargo: this.cargo_contacto,
              em_correo_contacto: this.correo_contacto,
              em_numero_contacto: this.numero_contacto,
              em_direccion: this.direccion,
              em_baja: true,
              em_nit: "",
              em_completo: true,
              em_gps: this.coordenadas_encuesta,
            })
            .then(() => {})
            .catch((error) => console.log("Error al guardar...: ", error));
          this.$store.state.n_max_expuestos = this.numero_expuestos;
          // CLIENTE EMPRESA
          this.$store.state.msp_c_key = id;
          // CLIENTE PRINCIPAL
          this.$store.state.msp_c_key_cliente_iper = this.id_cliente_iper;
          // FIN ALERTA GUARDADO
          this.proceso_copiar_matriz();
          NProgress.done();
          NProgress.remove();
        })();
      }
    },

    //-------- SEGUNDO PASO COPIADO MATRIZ --------//
    // PROCESO PARA COPIAR LA MATRIZ
    proceso_copiar_matriz() {
      (async () => {
        NProgress.start();
        var id_cliente = this.id_cliente;
        let consultarClienteEmpresa = await this.consultarClienteEmpresa(
          id_cliente
        );
        let existenciaPeligros = await this.existenciaPeligros(id_cliente);
        let excelProcesoConsulta = await this.excelProcesoConsulta(id_cliente);
        let excelZonaConsulta = await this.excelZonaConsulta(id_cliente);
        let excelActividadConsulta = await this.excelActividadConsulta(
          id_cliente
        );
        let excelTareasConsulta = await this.excelTareasConsulta(id_cliente);

        this.array_nuevo_peligros = [];
        excelTareasConsulta.forEach((tarea) => {
          let traerMatrizRiesgo = db
            .collection("matriz_riesgo")
            .where("em_id_tareas", "==", tarea.id_tarea);
          traerMatrizRiesgo.get().then((querySnapshot) => {
            if (querySnapshot.docs.length > 0) {
              querySnapshot.forEach((doc) => {
                let subti = "";
                let otro_subti = "";
                let eliminacion = "";
                let sustitucion = "";
                let controles_ing = "";
                let controles = "";
                let equipos = "";

                if (doc.data().em_subti) subti = doc.data().em_subti;
                if (doc.data().em_otro_subti)
                  otro_subti = doc.data().em_otro_subti;
                if (doc.data().em_eliminacion)
                  eliminacion = doc.data().em_eliminacion;
                if (doc.data().em_sustitucion)
                  sustitucion = doc.data().em_sustitucion;
                if (doc.data().em_controles_ing)
                  controles_ing = doc.data().em_controles_ing;
                else if (doc.data().em_control_ingenieria)
                  controles_ing = doc.data().em_control_ingenieria;
                if (doc.data().em_controles)
                  controles = doc.data().em_controles;
                else if (doc.data().em_controles_admin)
                  equipos = doc.data().em_controles_admin;
                if (doc.data().em_equipos) equipos = doc.data().em_equipos;
                else if (doc.data().em_epp) equipos = doc.data().em_epp;

                let id_proceso = tarea.id_proceso;
                let proceso_riesgo = "";
                excelProcesoConsulta.forEach((proceso) => {
                  if (proceso.id_proceso == id_proceso) {
                    proceso_riesgo = proceso.em_proceso_riesgo;
                  }
                });
                let id_zona = tarea.id_zona;
                let zona = "";
                excelZonaConsulta.forEach((zona_q) => {
                  if (zona_q.id_zona == id_zona) {
                    zona = zona_q.em_zona;
                  }
                });
                let id_acti = tarea.id_actividad;
                let actividades = "";
                excelActividadConsulta.forEach((actividad) => {
                  if (actividad.id_actividad == id_acti) {
                    actividades = actividad.em_actividades;
                  }
                });
                let id_tareas = tarea.id_tarea;
                let tareas = tarea.em_tareas;
                this.array_nuevo_peligros.unshift({
                  proceso_riesgo: proceso_riesgo,
                  id_proceso: id_proceso,
                  zona: zona,
                  id_zona: id_zona,
                  actividades: actividades,
                  id_acti: id_acti,
                  tareas: tareas,
                  id_tarea: id_tareas,

                  id_peligro: doc.data().em_id_peligro,
                  id_subcla: doc.data().em_id_subclasificacion,
                  id_efectos_posibles: doc.data().em_id_efectos_posibles,

                  descripcion: `${doc.data().em_descripcion}`,
                  clasificacion: `${doc.data().em_clasificacion}`,
                  tipo: `${doc.data().em_tipo}`,
                  rutinario: doc.data().em_rutinario,
                  subti: subti,
                  otro_subti: otro_subti,
                  efectos: doc.data().em_efecto_posible,
                  control_fuente: doc.data().em_c_fuente,
                  control_medio: doc.data().em_c_medio,
                  control_individuo: doc.data().em_c_individuo,

                  nivel_eficiencia: doc.data().em_nivel_eficiencia,
                  nivel_exposicion: doc.data().em_nivel_exposicion,
                  nivel_probabilidad: doc.data().em_nivel_probabilidad,
                  interpretacion: `${doc.data().em_interpretacion}`,
                  nivel_consecuencia: doc.data().em_nivel_consecuencia,
                  nivel_riesgo: doc.data().em_nivel_riesgo,
                  interpretacion_nr: `${doc.data().em_interpretacion_nr}`,
                  aceptabilidad: `${doc.data().em_aceptabilidad}`,

                  num_expuestos: doc.data().em_num_expuestos,
                  peor_consecuencia: `${doc.data().em_peor_consecuencia}`,

                  eliminacion: eliminacion,
                  sustitucion: sustitucion,
                  controles_ing: controles_ing,
                  controles: controles,
                  equipos: equipos,
                });
              });
            }
          });
        });
        await setTimeout(() => {
          if (
            this.$store.state.msp_c_key &&
            this.$store.state.msp_c_key_cliente_iper
          ) {
            this.arr_temp_procesos = [];
            for (let e = 0; e < this.array_nuevo_peligros.length; e++) {
              this.arr_temp_procesos.push({
                proceso_riesgo: this.array_nuevo_peligros[e].proceso_riesgo,
                zona: this.array_nuevo_peligros[e].zona,
                actividades: this.array_nuevo_peligros[e].actividades,
                tareas: this.array_nuevo_peligros[e].tareas,
              });
            }
            let set = new Set(this.arr_temp_procesos.map(JSON.stringify));
            this.arr_temp_procesos = Array.from(set).map(JSON.parse);
            // REGISTRAR LOS PZAT A LA DB
            this.registrar_proceso();
          } else {
            $("#modal_mostrar_matriz").modal("hide");
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Aún no ha registrado un Centro de Trabajo",
              showConfirmButton: false,
              timer: 1500,
            });
            NProgress.done();
            NProgress.remove();
            console.log("No ha registrado un cliente.");
            this.$store.state.estado_navbar_matriz_peligro =
              "registro_centro_trabajo";
          }
        }, 1600);
      })();
    },

    //-------- TERCER PASO COPIADO MATRIZ --------//
    registrar_proceso() {
      (async () => {
        for (let e = 0; e < this.arr_temp_procesos.length; e++) {
          const newProcesoRef = db.collection("proceso").doc();
          const id_proceso = newProcesoRef.id;

          const newZonaRef = db.collection("zona").doc();
          const id_zona = newZonaRef.id;

          const newActividadRef = db.collection("actividades").doc();
          const id_acti = newActividadRef.id;

          const newTareaRef = db.collection("tareas").doc();
          const id_tarea = newTareaRef.id;

          let proceso_riesgo = this.arr_temp_procesos[e].proceso_riesgo;
          let zona = this.arr_temp_procesos[e].zona;
          let actividades = this.arr_temp_procesos[e].actividades;
          let tareas = this.arr_temp_procesos[e].tareas;

          db.collection("proceso").doc(id_proceso).set({
            em_id_cliente: this.$store.state.msp_c_key,
            em_proceso_riesgo: proceso_riesgo,
          });
          db.collection("zona").doc(id_zona).set({
            em_id_cliente: this.$store.state.msp_c_key,
            em_id_proceso: id_proceso,
            em_zona: zona,
          });
          db.collection("actividades").doc(id_acti).set({
            em_id_cliente: this.$store.state.msp_c_key,
            em_id_proceso: id_proceso,
            em_id_zona: id_zona,
            em_actividades: actividades,
          });
          db.collection("tareas").doc(id_tarea).set({
            em_id_cliente: this.$store.state.msp_c_key,
            em_id_proceso: id_proceso,
            em_id_zona: id_zona,
            em_id_acti: id_acti,
            em_tareas: tareas,
          });
          this.registrar_peligro(
            id_proceso,
            id_zona,
            id_acti,
            id_tarea,
            proceso_riesgo,
            zona,
            actividades,
            tareas
          );
        }
      })();
    },

    //-------- CUARTO PASO COPIADO MATRIZ --------//
    registrar_peligro(
      id_proceso,
      id_zona,
      id_acti,
      id_tarea,
      proceso_riesgo,
      zona,
      actividades,
      tareas
    ) {
      (async () => {
        for (let e = 0; e < this.array_nuevo_peligros.length; e++) {
          if (
            this.array_nuevo_peligros[e].proceso_riesgo == proceso_riesgo &&
            this.array_nuevo_peligros[e].zona == zona &&
            this.array_nuevo_peligros[e].actividades == actividades &&
            this.array_nuevo_peligros[e].tareas == tareas
          ) {
            let newMatrizRef = db.collection("matriz_riesgo").doc();
            let id_matriz = newMatrizRef.id;
            db.collection("matriz_riesgo").doc(id_matriz).set({
              em_id_cliente_iper: this.$store.state.msp_c_key_cliente_iper,
              em_id_cliente: this.$store.state.msp_c_key,
              em_id_proceso: id_proceso,
              em_id_zona: id_zona,
              em_id_acti: id_acti,
              em_id_tareas: id_tarea,

              em_fecha_registro: firebase.firestore.FieldValue.serverTimestamp(),
              em_fecha_editado: firebase.firestore.FieldValue.serverTimestamp(),

              em_proceso: proceso_riesgo,
              em_zona: zona,
              em_actividad: actividades,
              em_tarea: tareas,

              em_id_peligro: this.array_nuevo_peligros[e].id_peligro,
              em_id_subclasificacion: this.array_nuevo_peligros[e].id_subcla,
              em_id_efectos_posibles: this.array_nuevo_peligros[e]
                .id_efectos_posibles,

              em_descripcion: this.array_nuevo_peligros[e].descripcion,
              em_clasificacion: this.array_nuevo_peligros[e].clasificacion,
              em_tipo: this.array_nuevo_peligros[e].tipo,
              em_rutinario: this.array_nuevo_peligros[e].rutinario,

              em_efecto_posible: this.array_nuevo_peligros[e].efectos,
              em_c_fuente: this.array_nuevo_peligros[e].control_fuente,
              em_c_medio: this.array_nuevo_peligros[e].control_medio,
              em_c_individuo: this.array_nuevo_peligros[e].control_individuo,
              em_antecedente: "",

              em_nivel_eficiencia: this.array_nuevo_peligros[e]
                .nivel_eficiencia,
              em_nivel_exposicion: this.array_nuevo_peligros[e]
                .nivel_exposicion,
              em_nivel_probabilidad: this.array_nuevo_peligros[e]
                .nivel_probabilidad,
              em_interpretacion: this.array_nuevo_peligros[e].interpretacion,
              em_nivel_consecuencia: this.array_nuevo_peligros[e]
                .nivel_consecuencia,
              em_nivel_riesgo: this.array_nuevo_peligros[e].nivel_riesgo,
              em_interpretacion_nr: this.array_nuevo_peligros[e]
                .interpretacion_nr,
              em_aceptabilidad: this.array_nuevo_peligros[e].aceptabilidad,

              em_num_expuestos: this.array_nuevo_peligros[e].num_expuestos,
              em_peor_consecuencia: this.array_nuevo_peligros[e]
                .peor_consecuencia,

              em_eliminacion: this.array_nuevo_peligros[e].eliminacion,
              em_sustitucion: this.array_nuevo_peligros[e].sustitucion,
              em_control_ingenieria: this.array_nuevo_peligros[e].controles_ing,
              em_controles_admin: this.array_nuevo_peligros[e].controles,
              em_epp: this.array_nuevo_peligros[e].equipos,
            });
            Swal.fire(
              "¡Matriz copiada!",
              "La matriz ha sido copiada correctamente.",
              "success"
            );
          }
        }
        this.copiar_matriz = false;
        this.$store.state.n_max_expuestos = "";
        // CLIENTE EMPRESA
        this.$store.state.msp_c_key = "";
        // CLIENTE PRINCIPAL
        this.$store.state.msp_c_key_cliente_iper = "";
        this.id_copiar_matriz = false;
        this.terminar_centro_trabajo();
        $("#modal_reg_proceso").modal("hide");
        NProgress.done();
        NProgress.remove();
      })();
    },

    //-------- FUNCIONES PARA EL MODAL DE COPIADO DE MATRIZ <- NUEVO PROCESO -> --------//
    // OBTENER COORDENADAS - REGISTRAR ENCUESTA
    obtener_ubicacion() {
      // LIMPIAR VARIABLES DE LONGITUD Y LATITUD
      this.latitud_encuesta = "";
      this.longitud_encuesta = "";
      this.coordenadas_encuesta = "";

      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.latitud_encuesta = position.coords.latitude;
          this.longitud_encuesta = position.coords.longitude;
          this.coordenadas_encuesta =
            this.latitud_encuesta + ", " + this.longitud_encuesta;

          // MENSAJE DE GUARDADO
          Swal.fire({
            position: "center",
            icon: "success",
            background: "transparent",
            html:
              '<h4 style="color: rgb(255, 255, 255)">¡Ubicación obtenida correctamente!</h4>',
            backdrop: `rgba(0,0,0,0.8)`,
            showConfirmButton: false,
            timer: 1500,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        });
      } else {
        console.log("¡El navegador no soporta la geolocalización!");
      }
    },

    // FUNCIÓN CONSULTAR CLIENTES POR NOMBRE
    consultar_clientes_por_nombre() {
      if (!this.cliente) {
        this.id_cliente_iper = "";
        this.sector_cliente = "";
      }
      db.collection("cliente_principal")
        .where("cl_cliente", "==", this.cliente)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.id_cliente_iper = doc.id;
            this.sector_cliente = doc.data().cl_sector;
          });
        })
        .catch((error) =>
          console.log("Error al obtener la información: ", error)
        );
    },

    // FUNCIÓN CARGAR SELECT CLIENTE
    cargar_clientes() {
      // CARGAR CLIENTES
      db.collection("cliente_principal")
        .where("cl_estado", "==", "0")
        .orderBy("cl_cliente")
        .onSnapshot((querySnapshot) => {
          this.clientes_iper = [];
          querySnapshot.forEach((doc) => {
            this.clientes_iper.push(doc.data().cl_cliente);
          });
        });
    },

    regional_select() {
      if (this.$store.state.global_privilegio_regionales_todas) {
        db.collection("nuevo_regional")
          .where("r_registrado_por", "==", this.$store.state.email)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.lista_regionales.push(doc.data().r_nueva_region);
              const set = new Set(this.lista_regionales.map(JSON.stringify));
              this.lista_regionales = Array.from(set).map(JSON.parse);
            });
          });
      } else {
        this.$store.state.global_privilegio_regional.forEach((x) => {
          this.lista_regionales.push(x.nombre_regional);
        });
      }
    },

    departamento_select() {
      this.lista_departamentos = [];
      this.lista_municipios = [];
      if (this.$store.state.global_privilegio_regionales_todas) {
        db.collection("nuevo_regional")
          .where("r_nueva_region", "==", this.regional)
          .where("r_registrado_por", "==", this.$store.state.email)
          .orderBy("r_departamento", "asc")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.lista_departamentos.push(doc.data().r_departamento);
            });
          });
      } else {
        this.$store.state.global_privilegio_regional.forEach((x) => {
          if (x.nombre_regional == this.regional) {
            x.departamentos.forEach((y) => {
              this.lista_departamentos.push(y.nombre_departamento);
            });
          }
        });
      }
    },

    municipio_select() {
      this.lista_municipios = [];
      if (this.$store.state.global_privilegio_regionales_todas) {
        db.collection("nuevo_regional")
          .where("r_nueva_region", "==", this.regional)
          .where("r_departamento", "==", this.departamento)
          .where("r_registrado_por", "==", this.$store.state.email)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.lista_municipios = doc.data().r_municipios;
            });
          });
      } else {
        this.$store.state.global_privilegio_regional.forEach((x) => {
          if (x.nombre_regional == this.regional) {
            x.departamentos.forEach((y) => {
              if (y.nombre_departamento == this.departamento) {
                this.lista_municipios = y.municipios;
              }
            });
          }
        });
      }
    },

    // FUNCIÓN PARA MOSTRAR LA FECHA ACTUAL
    fecha_hoy() {
      var n = new Date();
      // AÑO
      var y = n.getFullYear();
      // MES
      var m = n.getMonth() + 1;
      // DÍA
      var d = n.getDate();

      // ORDENAR
      this.fecha_actual = d + "/" + m + "/" + y;
    },
    terminar_centro_trabajo() {
      NProgress.start();
      this.limpiar_variables();
      this.limpiar_variables_globales();
      $("#modal_reg_proceso").modal("hide");
      NProgress.done();
      NProgress.remove();
    },
  },
};
</script>

<style scoped>
/* PONEMOS UN COLOR DE FONDOO Y REDONDEAMOS LAS ESQUINAS DEL TRACK */
.container::-webkit-scrollbar-track {
  background: #e1e1e1;
  border-radius: 4px;
}
/* CAMBIAMOS EL FONDO CUANDO ESTÉ EN ACTIVE O HOVER */
.container::-webkit-scrollbar-track:hover,
.container::-webkit-scrollbar-track:active {
  background: #d4d4d4;
}
#mySidenav a {
  position: fixed;
  left: -180px;
  transition: 0.3s;
  padding: 15px;
  padding-left: 5px;
  width: 200px;
  text-decoration: none;
  font-size: 20px;
  color: white;
  border-radius: 0px 64px 64px 0px !important;
  -moz-border-radius: 0px 64px 64px 0px !important;
  -webkit-border-radius: 0px 64px 64px 0px !important;
  border: 2px solid black;
  cursor: pointer;
}
#mySidenav a:hover {
  left: 0;
}
#about {
  top: 20px;
  background-color: #4caf50;
}
#download {
  top: 90px;
  background-color: #ee8813;
}
#copiarM {
  top: 90px;
  background-color: #ededed;
  color: black !important;
}
</style>